import { render, staticRenderFns } from "./Covid19Infantil.vue?vue&type=template&id=722ffd4a"
import script from "./Covid19Infantil.vue?vue&type=script&lang=js"
export * from "./Covid19Infantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports